// extracted by mini-css-extract-plugin
module.exports = {"backgroundWrapper":"CarImageGallery_backgroundWrapper__sjcqp","desktopCarImage":"CarImageGallery_desktopCarImage__xbd43"};